import type { ModelInfo } from '../../lib/api'

interface ModelSelectorProps {
  value: string | null
  onChange: (value: string | null) => void
  models: ModelInfo[]
  disabled?: boolean
}

function getCostTier(model: ModelInfo): string {
  const avgCost = (model.cost_per_1k_input + model.cost_per_1k_output) / 2
  if (avgCost <= 0.001) return '$'
  if (avgCost <= 0.005) return '$$'
  if (avgCost <= 0.03) return '$$$'
  return '$$$$'
}

function formatContextWindow(tokens: number): string {
  if (tokens >= 1_000_000) return `${(tokens / 1_000_000).toFixed(1)}M`
  if (tokens >= 1_000) return `${Math.round(tokens / 1_000)}K`
  return String(tokens)
}

const PROVIDER_ORDER = ['Google', 'OpenAI', 'Anthropic', 'Perplexity']

function groupByProvider(models: ModelInfo[]): Map<string, ModelInfo[]> {
  const groups = new Map<string, ModelInfo[]>()
  for (const provider of PROVIDER_ORDER) {
    groups.set(provider, [])
  }
  for (const model of models) {
    const provider = model.provider
    if (!groups.has(provider)) {
      groups.set(provider, [])
    }
    groups.get(provider)!.push(model)
  }
  for (const [key, arr] of groups) {
    if (arr.length === 0) groups.delete(key)
  }
  return groups
}

export function ModelSelector({ value, onChange, models, disabled }: ModelSelectorProps) {
  const grouped = groupByProvider(models)

  return (
    <select
      className="input"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
      disabled={disabled}
    >
      <option value="">Automatico (Router)</option>
      {Array.from(grouped.entries()).map(([provider, providerModels]) => (
        <optgroup key={provider} label={provider}>
          {providerModels.map((m) => (
            <option key={m.model_id} value={m.model_id}>
              {m.name} ({getCostTier(m)}) - {formatContextWindow(m.context_window)} ctx
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  )
}
